import parse from 'date-fns/parse';
import compareAsc from 'date-fns/compareAsc';
import { loadTitleDataSuccess } from './titleActions';
import * as markerIcons from '../components/Icons/timelineMarkers';


export const TIMELINE_SET_ERA = 'TIMELINE_SET_ERA';
export const TIMELINE_SET_SLIDE = 'TIMELINE_SET_SLIDE';
export const TIMELINE_CONTROLLER_NAVIGATE = 'TIMELINE_CONTROLLER_NAVIGATE';

export const setTimelineEra = (uid, slug) => ({
  type: TIMELINE_SET_ERA,
  payload: { uid, slug },
});

export const setActiveSlideIndex = (uid, index) => ({
  type: TIMELINE_SET_SLIDE,
  payload: { uid, index },
});

export const handleControllerNavigation = (uid, date) => ({
  type: TIMELINE_CONTROLLER_NAVIGATE,
  payload: { uid, date },
});

export const loadTimelineData = (titleProps) => (dispatch, getState) => {
  const { uid, eras, slides } = titleProps;
  const tlData = { uid, hasEras: false, activeSlideIndex: 0 };

  // Build deduplicated array of categories
  const buildCategoriesList = slides => (
    slides
      .map(i => i.category)
      .filter((elem, i, arr) => elem && arr.indexOf(elem) === i)
  );

  // Map category names to icon components
  const buildCategoryKey = slides => {
    const markerColors = getState().config.timelineMarkerColors;
    const iconsArray = Object.keys(markerIcons).map(k => markerIcons[k]);
    const catsArr = slides
      .map(i => i.category)
      .filter((elem, i, arr) => arr.indexOf(elem) === i)
      .sort((a, b) => {
        if (a === null) {
          return -1;
        } else {
          return a < b ? -1 : 1;
        }
      });
    return catsArr.reduce((catsObj, cat, i) => {
      const key = cat || 'default';
      catsObj[key] = {
        fill: markerColors[i % markerColors.length],
        icon: iconsArray[i % iconsArray.length],
      };
      return catsObj;
    }, {});
  };

  // Parse slide dates
  const getSlideDate = slide => {
    // Literal "Z" character in format string: we want to ignore the timezone in the API response (UTC)
    // and instead interpret all dates in the user's timezone.
    const fmtStr = "yyyy-MM-dd'T'HH':'mm':'ss'Z'"; // eslint-disable-line quotes
    if (typeof slide.date === 'string') {
      return parse(slide.date, fmtStr, new Date());
    } else {
      return slide.date;
    }
  };

  const sortSlidesByDate = slides => (
    [...slides].sort((a, b) => compareAsc(a.date, b.date))
  );

  // Perform transformations either on the root object or for each era
  const processTimelineObj = obj => {
    obj.categories = buildCategoriesList(obj.slides);
    obj.slides.forEach(slide => {
      slide.date = getSlideDate(slide);
    });
    obj.slides = sortSlidesByDate(obj.slides);
    obj.categoryKey = buildCategoryKey(obj.slides);
  };

  // If a timeline is divided into multiple "eras", then separate sets of slide data
  // are nested under each era. Otherwise the data is attached to the top-level object.
  if (eras.length !== 0) {
    tlData.hasEras = true;
    tlData.erasItems = eras.map(i => i.slug);
    tlData.activeEra = tlData.erasItems[0];
    tlData.erasBySlug = eras.reduce((erasObj, { slug, name, slides }) => {
      erasObj[slug] = { name, slides };
      return erasObj;
    }, {});

    tlData.erasItems.forEach(slug => {
      const era = tlData.erasBySlug[slug];
      processTimelineObj(era);
    });
    tlData.slideData = { ...tlData.erasBySlug[tlData.activeEra] };
  } else {
    tlData.slideData = { slides };
    processTimelineObj(tlData.slideData);
  }

  dispatch(loadTitleDataSuccess(tlData));
};



// WEBPACK FOOTER //
// ./src/actions/timelineTitleActions.js